// extracted by mini-css-extract-plugin
module.exports = {"section":"StoreVerification-section-3Fnr-","p":"StoreVerification-p-1ktxd","button":"StoreVerification-button-REnzs"};